import { Api } from '../../../utils/index.js';
export const baseEndpoint = 'https://products.polaris.me/v1/integrations';
export const krogerTokenEndpoint = `${Api.PRODUCTS}/v1/integrations/kro/auth/token`;
export const krogerRefreshEndpoint = `https://live.polaris.me${Api.PRODUCTS}/kro/auth/refresh`;
export const krogerCartEndpoint = `https://live.polaris.me${Api.PRODUCTS}/v1/integrations/kro/cart`;
const krogerApiBaseUri = 'https://api.kroger.com/v1/connect/oauth2/authorize';
const scope = 'cart.basic:write';
const clientId = 'groceryserver-polaris-26dedce8586f2431e2030f08e75d6107';
const responseType = 'code';
export const krogerApiRedirectUri = `${baseEndpoint}/kro/auth/callback`;
export const krogerAuthUri = `${krogerApiBaseUri}?client_id=${encodeURIComponent(clientId)}` +
    `&redirect_uri={{REDIRECT_URI}}` +
    `&response_type=${responseType}` +
    `&scope=${scope}`;
export const targetAuthEndpoint = `${Api.PRODUCTS}/v1/integrations/tgt/cart`;
